
import {
  defineComponent, defineAsyncComponent, reactive, toRefs, ref, provide,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { IJobModuleQuestionParseStu } from '@/views/Teacher/addJob/js/interface';
import useAnalysisHooks from '@/hooks/analysis.hooks';
import useUserHooks from '@/hooks/user.hooks';
import { message } from 'ant-design-vue';
import analysisService from '@/services/analysis.services';
import { promiseConfirm } from '@/lib/message';
import axios from '@/axios/api';

export default defineComponent({
  components: {
    theAnalysis: defineAsyncComponent(() => import('@/views/Public/jobPreview/index.vue')),
    questionModules: defineAsyncComponent(() => import('@/components/teacher/jobAnalysis/questionModule.vue')),
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const userHokks = useUserHooks();
    const analysisHooks = useAnalysisHooks();
    const { saveAssignmentStatusApi, queryScoreDataByAssignIdStuCode } = analysisService();
    /** 子组件参数 */
    const comData = reactive({
      jobId: route.query.jobId as string,
      view: route.query.view as 'preview'|'see'|'submit',
      assignmentId: route.query.assignmentId as string,
      assignmentModel: route.query.assignmentModel as string,
      stuCode: route.query.stuCode as string,
      questionLoading: false,
      analysisScore: 0, // 得分
    });
    provide('jobView', comData.view);
    provide('userRole', userHokks.getUserInfo().role);
    provide('assignmentId', comData.assignmentId); // 分配表id
    provide('assignmentModel', comData.assignmentModel); // 分配模式
    provide('stuCode', comData.stuCode); // 批改的学生code

    /**
     * 获得该学生分数
     * 获得教师批改了哪些题目
     */
    const getScore = async () => {
      if (comData.view === 'see') {
        const score = await queryScoreDataByAssignIdStuCode(comData.assignmentId, comData.stuCode);
        comData.analysisScore = score;
      }
    };

    /**
     * axios.queryAssignHomeworkById(jobId) —— 用于获得有没有发布
     */
    const getPublishStatus = async () => {
      if (comData.view === 'see') {
        const { data } = await axios.queryAssignHomeworkById(comData.assignmentId);
        analysisHooks.currentAssignmentPublish.set(data.data.publishStates ? '1' : '0');
      }
    };

    /** 问题模块 */
    const moduleList = ref<IJobModuleQuestionParseStu[]>([]); // 问题模块
    const initQuestion = async () => {
      await getPublishStatus();
      comData.questionLoading = true;
      const data = await analysisHooks.listQuestionDataByJobId(comData.jobId);
      let stuData = data;
      if (comData.view === 'see') {
        stuData = await analysisHooks.listQuestionStuAnswer(data, comData.assignmentId, { userId: comData.stuCode });
      }
      await getScore();
      moduleList.value = stuData;
      comData.questionLoading = false;
    };

    /** 提交 */
    const onSubmit = () => {
      console.log('onSubmit');
      promiseConfirm('提交后不能修改，确定提交吗?', async () => {
        await saveAssignmentStatusApi(comData.assignmentId);
        message.success('提交成功!');
        router.back();
      }, undefined, () => {
        router.back();
      });
    };

    initQuestion();
    return {
      ...toRefs(comData),
      onSubmit,
      moduleList,
      initQuestion,
    };
  },
});
